import { darken, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableRowRoot: {
    display: 'grid',
    height: 100,
    // marginBottom: 4,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    borderRadius: 20,
    cursor: 'pointer',
    paddingLeft: 12,
    transition: 'background-color 0.3s ease-in-out',
    width: '100%',
    textAlign: 'unset',
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? darken(theme.palette.background.default, 0.3)
          : '#f0f0f0'
    }
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '24fr 15fr',
    // height: 100,
    paddingTop: 20,
    paddingBottom: 20,
    marginBottom: 4,
    alignItems: 'center',
    // backgroundColor: theme.palette.background.paper,
    borderRadius: 20,
    cursor: 'pointer',
    // paddingLeft: 12,
    // transition: 'background-color 0.3s ease-in-out',
    width: '100%',
    textAlign: 'unset',
    // '&:hover': {
    //   backgroundColor: '#f0f0f0'
    // }
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '5fr 2fr'
    }
  },
  nameCell: {
    display: 'flex'
  },
  code: {
    // [theme.breakpoints.down('sm')]: {
    //   textAlign: 'center'
    // }
  }
}))
export default useStyles
